import { render, staticRenderFns } from "./ns-password-lost.vue?vue&type=template&id=0d387e0e&"
import script from "./ns-password-lost.vue?vue&type=script&lang=js&"
export * from "./ns-password-lost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports